import { defineComponent as n, createElementBlock as t, openBlock as o, createCommentVNode as l, renderSlot as s } from "vue";
const i = { class: "flex flex-col gap-2" }, r = {
  key: 0,
  class: "font-bold"
}, c = {
  key: 1,
  class: "text-c-2 mb-4 leading-[21px]"
}, m = /* @__PURE__ */ n({
  __name: "SettingsSection",
  setup(a) {
    return (e, d) => (o(), t("div", i, [
      e.$slots.title ? (o(), t("h3", r, [
        s(e.$slots, "title")
      ])) : l("", !0),
      e.$slots.description ? (o(), t("p", c, [
        s(e.$slots, "description")
      ])) : l("", !0),
      s(e.$slots, "default")
    ]));
  }
});
export {
  m as default
};
